import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, SelectItem } from 'primeng/api';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromStore from '../../../store';
import { Store, select } from '@ngrx/store';
import * as fromFeature from '../../../my-features';
import { Confirm_button } from '../../../../environments/environment';
import {CryptoService} from '../../../services/crypto.service';
import { updateInfoType, alertMapping } from '../../../shareModel';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UpdateInfoModel } from '../../../my-features/updateInfo/update-info.model';

@Component({
  standalone: false,
  selector: 'app-trap-detail',
  templateUrl: './trap-detail.component.html',
  styleUrls: ['./trap-detail.component.css']
})
export class TrapDetailComponent implements OnInit {
  private componentDestroyed = new Subject();
  Confirm_button = Confirm_button;
  trapMgtList_cols: any[] = [
    { field: 'category', header: 'Category', width: '150', class: 'col-nowrap', disabled: false },
    { field: 'trapName', header: 'Trap Name', width: '250', class: 'col-nowrap', disabled: false },
    { field: 'trapOID', header: 'Trap OID', width: '250', class: 'col-nowrap', disabled: false },
    { field: 'desc', header: 'Description', width: '400', class: 'col-nowrap', disabled: false },
    { field: 'level', header: 'Alert Level', width: '150', class: 'col-nowrap', disabled: false },
  ];
  trapMgtList = [];
  trap_Brand: string;
  trap_Name: string;
  trap_LastUpdateTime: string;
  selectedTrap: any;
  dialogInput: {
    id?: number;
    UpdateType: string;
    category: number;
    trapName: string;
    trapOID: string;
    desc: string;
    level: number;
  };
  categoryOptions: SelectItem[] = [];
  levelOptions: SelectItem[] = [
    { label: 'Information', value: 0 },
    { label: 'Warning', value: 1 },
    { label: 'Critical', value: 2 },
    { label: 'Offline', value: 3 }
  ];
  trap_Id: number;
  displayDialog: boolean = false;
  displayConfirmDialog: boolean = false;
  gatewayMIBTrapDetailList = [];
  categoryList = [];
  gatewayCategoryDic = [];
  UpdateInfoParam = {} as UpdateInfoModel;
  constructor(
    private router: Router,
    private store: Store<fromStore.State>,
    private cryptoService: CryptoService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService) {
    
    this.trap_Id = parseInt(this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('hashId')), 10);
    const param = {
      otp: '',
      InfoId: this.trap_Id
    }
    this.ngxService.start();
    this.store.dispatch(new fromFeature.ReadMgtTrapDetail(param));
    this.store.dispatch(new fromFeature.ReadMgtAttribute());
    this.store.dispatch(new fromFeature.ReadCategoryListByUser());

    // Get User Info
    this.store.pipe(select(fromStore.getCurrentUser)).subscribe(res => {
      if (res.authority && res.authority !== 2) {
        this.router.navigate(['/index']);
      }
    });

    combineLatest(this.store.select(fromStore.ReadMgtTrapDetail), this.store.select(fromStore.ReadCategoryList),).pipe(takeUntil(this.componentDestroyed))
    .subscribe(([trapdata, categoryList] ) => {
      debugger;
      if ((categoryList !== undefined && categoryList !== null)) {
        if (categoryList.length > 0) {
          this.gatewayCategoryDic = [];
          this.categoryList = [];
          this.categoryOptions = [];
          [...categoryList].sort(function (a: any, b: any) {
            return a.Value - b.Value;
          }).map((c) => {
            this.gatewayCategoryDic[c.Value] = c;
            this.categoryList.push(c)
            this.categoryOptions.push({
              label: c.Category, value: c.Value
            })
          })
        }
      }
      if (trapdata !== undefined && trapdata !== null) {
          this.ngxService.start();
          this.gatewayMIBTrapDetailList = trapdata;
          this.gettrapMgtList(trapdata);
        }
    });

    // Update Info
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.isLoading && res.isLoaded) {
        if (res.type === updateInfoType.AddMgtTrapDetail || res.type === updateInfoType.UpdateMgtTrapDetail || res.type === updateInfoType.DeleteMgtTrapDetail) {
          
          this.messageService.clear();
          if (res.isSaved) {
            const param = {
              otp: '',
              InfoId: this.trap_Id
            }
            this.store.dispatch(new fromFeature.ReadMgtTrapDetail(param));
            this.messageService.add({ severity: 'success', summary: res.msg });
          } else {
            this.messageService.add({ severity: 'error', summary: res.msg });
          }
          this.resetUpdateInfoState();
        }
      }
    })
  }

  ngOnInit() {
    this.initDialogInput();
  }

  gettrapMgtList(trapdata) {
    if (trapdata !== undefined && trapdata !== null) {
      
      this.trap_Brand = trapdata.Brand;
      this.trap_Name = trapdata.Name;
      this.trap_LastUpdateTime = trapdata.UpdateTime !== null ? moment(Number(trapdata.UpdateTime) * 1000).format('YYYY/MM/DD') : '';
      if (trapdata.Data !== undefined && trapdata.Data !== null && trapdata.Data.length > 0) {
        this.trapMgtList = [];
        console.log(this.gatewayCategoryDic);
        for (const i in trapdata.Data) {
          const item = trapdata.Data[i];
          if (item !== undefined) {
            this.trapMgtList.push({
              id: item.Id,
              category: item.Category,
              categoryStr: this.gatewayCategoryDic !== undefined && this.gatewayCategoryDic[item.Category] !== undefined ? this.gatewayCategoryDic[item.Category].Category : '',
              trapName: item.TrapName,
              trapOID: item.Oid,
              desc: item.Description,
              level: item.AlertLevel,
              levelStr: alertMapping[item.AlertLevel].status,
            })
          }
        }
      }
    }
    
    this.ngxService.stop();
  }

  initDialogInput() {
    this.dialogInput = {
      id: 0,
      UpdateType: 'Add SNMP Trap',
      category: 0,
      trapName: '',
      trapOID: '',
      desc: '',
      level: 0,
    };
  }

  showDialog() {
    this.initDialogInput();
    this.displayDialog = true;
  }

  showEditDialog() {
    this.displayDialog = true;
    this.dialogInput = {
      id: this.selectedTrap.id,
      UpdateType: 'Edit SNMP Trap',
      category: this.selectedTrap.category,
      trapName: this.selectedTrap.trapName,
      trapOID: this.selectedTrap.trapOID,
      desc: this.selectedTrap.desc,
      level: this.selectedTrap.level
    };
    
  }

  saveTrapData() {
    let param = {
      otp: '',
      Oid: this.dialogInput.trapOID,
      TrapName: this.dialogInput.trapName,
      Description: this.dialogInput.desc,
      AlertLevel: this.dialogInput.level
    } as any
    if (this.dialogInput.UpdateType === 'Add SNMP Trap') {
      param = {...param,
        InfoId: this.trap_Id,
        Category: this.dialogInput.category
      }
      this.store.dispatch(new fromFeature.AddMgtTrapDetail(param));
    } else {
      param = {...param, Id: this.dialogInput.id}
      this.store.dispatch(new fromFeature.UpdateMgtTrapDetail(param));
    }
    this.displayDialog = false;
  }

  showConfirmDialog() {
    this.displayConfirmDialog = true;
  }

  deleteTrapData() {
    const param = {
      otp: '',
      Id: this.selectedTrap.id
    }
    this.store.dispatch(new fromFeature.DeleteMgtTrapDetail(param));
    this.displayConfirmDialog = false;
  }

  backClicked() {
    this.router.navigate(['/management/gateway']);
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
